import { render, staticRenderFns } from "./ProcessShow.vue?vue&type=template&id=6a1a55b9&"
import script from "./ProcessShow.vue?vue&type=script&lang=js&"
export * from "./ProcessShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports